import { uiEventTypes } from 'events/ui';
import updateClientUnreadButton from 'app/dom_mutators/updateClientUnreadButton';

export default function updateUnreadMessageCount(unreadMessageCount) {
  if (isNaN(unreadMessageCount)) {
    throw new Error('no count supplied when trying to update unread message count');
  }

  // update the state of the customer's custom button if one is rendered in the DOM
  updateClientUnreadButton(unreadMessageCount);

  return dispatch => dispatch({ type: uiEventTypes.UPDATE_UNREAD_MESSAGE_COUNT, payload: { unreadMessageCount } });
}
